<template>
  <div>
    <div v-if="!hasDevice">
      This user has not enrolled a device in JumpCloud Protect Mobile Push
    </div>

    <div
      v-else
      :class="$style.tableContainer"
    >
      <table :class="$style.jcProtectDeviceTable">
        <thead>
          <tr>
            <th>Display Label</th>
            <th>Device Type</th>
            <th>Device OS</th>
            <th>Device Encryption</th>
            <th>App Version</th>
            <th>Authentication</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <JCProtectDeviceTableRow
            v-for="endpoint in pushEndpoints"
            :key="endpoint.id"
            :endpoint="endpoint"
          />
        </tbody>
      </table>

      <Warning
        v-if="shouldShowPendingWarning"
        isDismissable
        @dismiss="handleDismiss"
      >
        This user has not completed enrollment.
        They can finish enrollment or enroll a new device in the User Portal.
      </Warning>
    </div>
  </div>
</template>

<script>
// Framework
import { mapState } from 'vuex';

// Constants
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';

// Components
import JCProtectDeviceTableRow from 'client/systemusers/UserDetails/JCProtectDeviceTableRow.vue';
import Warning from 'components/Warning/Warning.vue';

// Modules
const pushMfaUserEndpointsModule = StoreModuleMap[ItemTypeConsts.pushMfaUserEndpoints];

export default {
  name: 'JCProtectDeviceTable',

  components: {
    JCProtectDeviceTableRow,
    Warning,
  },

  data() {
    return {
      hasPendingWarningBeenDismissed: false,
    };
  },

  computed: {
    ...mapState(pushMfaUserEndpointsModule, {
      pushEndpoints: state => state.endpoints,
    }),

    hasDevice() {
      return !!this.pushEndpoints.length;
    },

    isActivationPending() {
      /**
       * Right now we only support one device for Push -
       * Revist with UX to see how we want to handle multiple
       * devices with varying statuses
       */
      const [endpoint] = this.pushEndpoints;

      return endpoint.isActivationPending;
    },

    shouldShowPendingWarning() {
      return this.isActivationPending && !this.hasPendingWarningBeenDismissed;
    },
  },

  methods: {
    handleDismiss() {
      this.hasPendingWarningBeenDismissed = true;
    },
  },
};
</script>
<style module>
.jcProtectDeviceTable {
  width: 100%;
}

.jcProtectDeviceTable thead {
  border-bottom: 1px solid #d3dde4;
}

.jcProtectDeviceTable thead th {
  padding: 0 0.625rem 0.625rem 0;
  white-space: nowrap;
}

.jcProtectDeviceTable tbody tr {
  height: 4rem;
}

.jcProtectDeviceTable thead th:last-child {
  width: 10%;
}

.jcProtectDeviceTable thead th:last-child,
.jcProtectDeviceTable tbody td:last-child {
  text-align: center;
}
</style>
